import axios from "axios";
import type { CheckTypeKey } from "./pricelist";
import type { TariffBuyResponse } from "./user";

export interface LimitsEnrichItem {
  id?: string;
  checkType: CheckTypeKey;
  amount: number;
  price: number;
  active?: boolean;
}

export type LimitsEnrichItemPayload = {
  checkType: CheckTypeKey;
  amount: number;
  price: number;
  active: boolean;
};

export interface LimitEnrichBuyItem {
  enrichItemId: string;
  count: number;
}

export interface LimitEnrichBuyRequest {
  items: LimitEnrichBuyItem[];
}

export const fetchLimitsEnrichItemList = (): Promise<LimitsEnrichItem[]> =>
  axios
    .get<LimitsEnrichItem[]>("/limits/enrich")
    .then((resp) => (Array.isArray(resp.data) ? resp.data : []));

export const createLimitsEnrichItem = (
  payload: LimitsEnrichItemPayload
): Promise<LimitsEnrichItem> =>
  axios.post<LimitsEnrichItem>("/limits/enrich/item", payload).then((resp) => resp.data);

export const updateLimitsEnrichItem = (
  id: string,
  payload: LimitsEnrichItemPayload
): Promise<LimitsEnrichItem> =>
  axios
    .put<LimitsEnrichItem>(`/limits/enrich/item/${encodeURIComponent(id)}`, payload)
    .then((resp) => resp.data);

export const buyLimitEnrich = (payload: LimitEnrichBuyRequest): Promise<TariffBuyResponse> =>
  axios.post<TariffBuyResponse>("/limits/enrich", payload).then((resp) => resp.data);
